import React from 'react';
import { Header } from './components/site/Header';
import { Hero } from './components/site/Hero';
import { TrustStrip } from './components/site/TrustStrip';
import { Products } from './components/site/Products';
import { HowItWorks } from './components/site/HowItWorks';
import { SystemSpotlight } from './components/site/SystemSpotlight';
import { Gallery } from './components/site/Gallery';
import { Reviews } from './components/site/Reviews';
import { ServiceAreas } from './components/site/ServiceAreas';
import { QuoteCTA } from './components/site/QuoteCTA';
import { Footer } from './components/site/Footer';
export function App() {
  return <div className="min-h-full w-full bg-white font-sans text-navy-900 antialiased" data-id="element-0" data-mp="31c1hoavsjsfq">
      <Header data-id="element-1" data-mp="2wj8evsjvuu6a" />
      <main data-id="element-2" data-mp="2wip7v6vrtq71">
        <Hero data-id="element-3" data-mp="2whxd1y9zzwht" />
        <TrustStrip data-id="element-4" data-mp="28ufoscpxzgjl" />
        <Products data-id="element-5" data-mp="28tw972nrl48q" />
        <HowItWorks data-id="element-6" data-mp="28t4m6g88geu2" />
        <SystemSpotlight data-id="element-7" data-mp="28sl48zil1qg1" />
        <Gallery data-id="element-8" data-mp="23vcjcr61v8b3" />
        <Reviews data-id="element-9" data-mp="23vuokdaowwv5" />
        <ServiceAreas data-id="element-10" data-mp="23u9tmmkgrbwr" />
        <QuoteCTA data-id="element-11" data-mp="23ut9zyugts8o" />
      </main>
      <Footer data-id="element-12" data-mp="23ti5fwt74ggi" />
    </div>;
}